import { render, staticRenderFns } from "./RepairRegistrationEdit.vue?vue&type=template&id=fc0573a8&scoped=true"
import script from "./RepairRegistrationEdit.vue?vue&type=script&lang=js"
export * from "./RepairRegistrationEdit.vue?vue&type=script&lang=js"
import style0 from "./RepairRegistrationEdit.vue?vue&type=style&index=0&id=fc0573a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0573a8",
  null
  
)

export default component.exports